import {useEffect, useState} from 'react';
import {InputNumber, Select, Radio, Space, message} from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';

export default function CorporationComboSet(props) {
  const [list, setList] = useState(props?.data?.option?.defaultValue?.list || [
    { durationValue: 1, durationUnit: 'year', discount: 10, defaultSelected: true }
  ]);

  useEffect(() => {
    props.verification(props.data, {
      list: list
    });
  }, [props.data, list]);

  const handleAdd = () => {
    setList([...list, { durationValue: 1, durationUnit: 'year', discount: 0, defaultSelected: false }]);
  };

  const handleDelete = (index) => {
    if (list.length <= 1) {
      message.warning('至少需要保留一个套餐内容');
      return;
    }
    const newList = [...list];
    newList.splice(index, 1);
    setList(newList);
  };

  const handleChange = (index, field, value) => {
    const newList = [...list];
    newList[index][field] = value;
    setList(newList);
  };

  const handleRecommendChange = (index) => {
    const newList = list.map((item, i) => ({
      ...item,
      defaultSelected: i === index
    }));
    setList(newList);
  };

  const checkDuplicate = (index) => {
    const current = list[index];
    return list.some((item, i) => i !== index && item.durationValue === current.durationValue && item.durationUnit === current.durationUnit);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {list.map((item, index) => {
        const isDuplicate = checkDuplicate(index);
        return (
          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ flex: 1, border: '1px solid #d5d1d1', borderRadius: '4px', padding: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: isDuplicate ? '4px' : '16px' }}>
                <div style={{ width: '80px', fontWeight: 'bold' }}>套餐时长：</div>
                <Space>
                  <InputNumber
                    min={1}
                    max={99}
                    step={1}
                    precision={0}
                    controls={false}
                    value={item.durationValue}
                    onChange={(val) => handleChange(index, 'durationValue', val)}
                    style={{ width: '120px' }}
                  />
                  <Select
                    value={item.durationUnit}
                    onChange={(val) => handleChange(index, 'durationUnit', val)}
                    style={{ width: '80px' }}
                    options={[
                      { value: 'year', label: '年' }, // year/month/day
                      { value: 'month', label: '月' },
                      { value: 'day', label: '日' } 
                    ]}
                  />
                </Space>
              </div>
              {isDuplicate && <div style={{ color: 'red', fontSize: '12px', marginBottom: '12px', paddingLeft: '80px' }}>套餐时长有重复，请修改</div>}
              
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '80px', fontWeight: 'bold' }}>套餐折扣：</div>
                <InputNumber
                  style={{ width: "208px" }}
                  min={0}
                  max={10}
                  step={0.1}
                  precision={1}
                  controls={false}
                  addonAfter={"折"}
                  value={item.discount}
                  onChange={(val) => handleChange(index, 'discount', val)}
                />
              </div>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', justifyContent: 'center' }}>
              <Radio
                checked={item.defaultSelected}
                onChange={() => handleRecommendChange(index)}
              >
                推荐
              </Radio>
              <DeleteOutlined
                style={{ fontSize: '16px', cursor: 'pointer' }}
                onClick={() => handleDelete(index)}
              />
              {index === list.length - 1 && (
                <PlusCircleOutlined
                  style={{ fontSize: '16px', cursor: 'pointer', color: '#1890ff' }}
                  onClick={handleAdd}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
